"use client";

import { FacebookIcon, LinkedinIcon, XIcon } from "icons";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "next-share";
import { Text } from "ui-components";

export interface ISocialShareProps {
  url?: string;
  title?: string;
}

export function SocialShare({
  url = "",
  title,
}: ISocialShareProps): JSX.Element {
  return (
    <div className="flex flex-col gap-2">
      {!!title && <Text>{title}</Text>}
      <div className="flex flex-row gap-2">
        <FacebookShareButton url={url}>
          <FacebookIcon className="w-8" />
        </FacebookShareButton>
        <LinkedinShareButton url={url}>
          <LinkedinIcon className="w-8" />
        </LinkedinShareButton>
        <TwitterShareButton url={url}>
          <XIcon className="w-8" />
        </TwitterShareButton>
      </div>
    </div>
  );
}
